import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { LogRegister } from '../../log-register';
import * as SystemLogActions from '../../state/system-log-register.actions';
import { logRegisterAdapterActions, logRegisterInitialFilter } from '../../state/system-log-register.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-log-register',
    styleUrls: ['./system-log-register.component.scss'],
    templateUrl: './system-log-register.component.html',
    standalone: false
})
export class SystemLogRegisterComponent extends LogRegister {
   constructor(public store: Store) {
      super(store);
      this.columns = [
         'createUserDate',
         'message',
         'severityId',
         'typeId',
         'areaId',
         'accountName',
         'systemLogActionsMenu',
      ];
   }

   ngOnInit() {
      this.store.dispatch(logRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(logRegisterAdapterActions.pageEnter());
   }

   onOpenDialog(event: { callLogs: any }) {
      this.store.dispatch(SystemLogActions.openDialog(event));
   }

   onOpenLogDialog(event: { callLogs: any }) {
      this.store.dispatch(SystemLogActions.openLogDialog(event));
   }
}
